import Vue from 'vue'

import { ModalPlugin } from 'bootstrap-vue'
Vue.use(ModalPlugin)

const vm = new Vue()
export default vm.$bvModal
